export function transformStorePhone(phoneNumber) {
    let transformed = phoneNumber;
    if (phoneNumber && typeof phoneNumber === 'string') {
        const numArray = phoneNumber.split('.');
        if (numArray.length === 3) {
            transformed = `(${numArray[0]}) ${numArray[1]}-${numArray[2]}`;
        }
    }
    return transformed;
}
/**
 * For use in links (i.e. <a href="tel:1231231231">Number</a>)
 */
export function toRawPhoneNumber(string) {
    if (string) {
        return string.replace(/[^\d+]/g, '');
    }
}
export function transformStoreAddress(store) {
    let transformed = '';
    if (store) {
        if (store.ADDRESS) {
            transformed += store.ADDRESS;
        }
        if (store.ADDRESS2) {
            transformed += `, ${store.ADDRESS2}`;
        }
        if (store.CITY) {
            transformed += `, ${store.CITY}`;
        }
        if (store.STATE) {
            transformed += `, ${store.STATE}`;
        }
        if (store.ZIP) {
            transformed += ' ' + store.ZIP;
        }
    }
    return transformed;
}
/**
 * converts a price and currency into a "money" format
 *
 */
export function toMoney(price, currency, alwaysShowDecimals = false) {
    let money = (price / 100).toFixed(2);
    if (!alwaysShowDecimals) {
        money = money.replace(".00", "");
    }
    return `${currency}${money}`;
}
export function capitalizeFirstLetter(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
}
